import * as styles from "../../../styles/DefaultSetting";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import userSlice from "../../../reducer/user";
import { useAppDispatch } from "../../../store";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import Modal from "../../../components/Modal";
import { set } from "date-fns";

dayjs.locale("ko");

interface FeedType {
  farmId: number | null | undefined;
  feedInventory: number | null | undefined;
  feedLowLimit: number | null | undefined;
  feedName: string | null | undefined;
  feedPurchaseAmount: number | null | undefined;
  feedPurchaseDate: string | null | undefined;
  feedRemain: number | null | undefined;
  manageFeedId: number | null | undefined;
};

const Feedmanagement = () => {

  const navigate = useNavigate();

  const [feedList, setFeedList] = useState<FeedType[]>();

  const dispatch = useAppDispatch();

  let [putdata, setPutdata] = useState<{
    [key: string]: string | number | null | undefined;
    feedName: string | null | undefined;
    feedInventory: number | null | undefined;
    feedRemain: number | null | undefined;
    feedPurchaseDate: string | null | undefined;
    feedPurchaseBags: number | null | undefined;
    feedPurchaseBagUnit: number | null | undefined;
    feedLowLimit: number | null | undefined;
    manageFeedId: number | null | undefined;
  }>({
    feedName: null,
    feedInventory: null,
    feedRemain: null,
    feedPurchaseDate: null,
    feedPurchaseBags: null,
    feedPurchaseBagUnit: null,
    feedLowLimit: null,
    manageFeedId: null,
  });

  let [date, setDate] = useState({
    date: "",
    time: "",
  });
  const [deletemodal, setDeletemodal] = useState<boolean>(false);
  const [manageFeedIds, setManageFeedIds] = useState<any>();

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath(`/Feedmanagement`));
  }, []);

  useEffect(() => {
    feedlist();
  }, []);

  const feedlist = async () => {
    try {
      const res = await axios.get(`/ifactory/api/feed?farmId=${localStorage.getItem("targetfarm")}`);
      const response = res.data;

      // response 의 값의 type 체크 
      const feedTypeKeys: (keyof FeedType)[] = ['feedInventory', 'feedLowLimit', 'feedName', 'feedPurchaseAmount', 'feedPurchaseDate', 'feedRemain', 'manageFeedId'];
      response.forEach((item: any) => {
        feedTypeKeys.forEach((key) => {
          if (!(key in item)) { // item이 key를 속성으로 가지고 있지 않다면,
            confirmAlert({
              title: `[${key}] 속성 값의 타입이 일치하지 않습니다. 시스템 관리자에게 문의하세요.`,
              buttons: [{ label: "Yes" }],
            });
          }
        });
      });

      // response의 feedPurchaseDate를 YYYY-MM-DD 형식으로 변환
      response.map((item: FeedType) => item.feedPurchaseDate = dayjs(item.feedPurchaseDate).format("YYYY-MM-DD"));

      setFeedList(response);
    } catch (error: any) {
      confirmAlert({
        title: error.response.data,
        buttons: [{ label: "Yes" }],
      });
    }
  };

  let [modal, setModal] = useState<boolean>(false);
  useEffect(() => {
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modal]);

  const FeedChange = (item: any) => {
    item.feedPurchaseDate = dayjs(item.feedPurchaseDate).format("YYYY-MM-DD");

    setPutdata({
      feedName: item.feedName,
      feedInventory: item.feedInventory,
      feedRemain: item.feedRemain,
      feedPurchaseDate: item.feedPurchaseDate,
      feedPurchaseBags: null,
      feedPurchaseBagUnit: null,
      feedLowLimit: item.feedLowLimit,
      manageFeedId: item.manageFeedId,
    });

    // setPutdata(item);
    setModal(!modal);
  };

  const InputHandler = (e: any) => {
    const { name, value } = e.target;
    setPutdata({ ...putdata, [name]: value });
  };

  const DateInputHandler = (e: any) => {
    const { name, value } = e.target;
    setDate({ ...date, [name]: value });
  };

  const Putsubmit = () => {
    if (!putdata.feedPurchaseDate) {
      return alert("사료구입날짜를 입력해주세요");
    }

    // 1. 사료구입량 또는 재고하한값이 입력되어 있는지 확인
    if (!putdata.feedPurchaseBags && !putdata.feedLowLimit) {
      return alert("사료구입량 또는 재고하한값을 입력해주세요");
    }

    // 2. 사료구입량이 입력되었으면 포대 단위, 재고하한값이 입력되었는지 확인
    if (putdata.feedPurchaseBags) {
      if (!putdata.feedPurchaseBagUnit) {
        return alert("포대 단위를 입력해주세요");
      } else if (!putdata.feedLowLimit) {
        return alert("재고하한값을 입력해주세요");
      }
    } else {
      if (!putdata.feedLowLimit) {
        return alert("재고하한값을 입력해주세요");
      }
    }

    /*
      putdata에서 key가 feedPurchaseBags, feedPurchaseBagUnit, feedPurchaseDate, feedLowLimit 대상만으로
      value가 존재하는 key value만 추출하여 sendData에 저장한다.
    */
    const sendData = Object.keys(putdata)
      .filter(key => ["feedPurchaseBags", "feedPurchaseBagUnit", "feedPurchaseDate", "feedLowLimit"].includes(key))
      .reduce((obj, key) => {
        // value값이 null일 경우 API parameter에 포함시키지 않는다.
        if (putdata[key] !== null) {
          obj[key] = key === "feedPurchaseDate" ? putdata[key] : Number(putdata[key]);
        }
        return obj;
      }, {} as any);



    // 데이터가 존재하지 않다면 API parameter에 포함시키지 않는다.
    axios
      .put(`ifactory/api/feed/${putdata.manageFeedId}`, sendData)
      .then((res) => {
        confirmAlert({
          title: "수정되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        window.location.reload();
      })
      .catch((error) => {
        confirmAlert({
          title: error.response.data,
          buttons: [{ label: "Yes" }],
        });
      });
  };
  const FeedDelete = (manageFeedId: number) => {
    setManageFeedIds(manageFeedId);
    setDeletemodal(true);
  };

  const deleteCommnetfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        axios
          .delete(`ifactory/api/feed/${manageFeedIds}`)
          .then((res) => {
            confirmAlert({
              title: "삭제되었습니다.",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
            feedlist();
            setDeletemodal(false);
          })

          .catch((error) => {
            confirmAlert({
              title: error.response.data,
              buttons: [{ label: "Yes" }],
            });
          });
      } else if (type === "NO") {
        setDeletemodal(false);
      }
    },
    [manageFeedIds]
  );


  return (
    <styles.Container>
      <styles.PageTop>
        <p className="move-btn">
          <img src="./img/ArrowLeft.svg" onClick={() => { navigate("/MainPage") }} alt="좌향버튼" />
        </p>
        <p className="pagetit">기본설정</p>
      </styles.PageTop>
      <styles.PageTitle>
        <div className="title">
          <p>사료 관리</p>
          <button onClick={() => { navigate("/FeedAdd") }} >추가</button>
        </div>
      </styles.PageTitle>

      <styles.ContentBox>
        {feedList &&
          feedList.map((item: any, idx: number) => {
            let feedday = dayjs(item.feedPurchaseDate).format(
              "YYYY년 MM월 DD일"
            );

            const feeddayfunc = () => {
              if (feedday === "Invalid Date") {
                return "날짜가 없습니다.";
              } else {
                return feedday;
              }
            };

            return (
              <styles.ContentItem key={idx}>
                <div className="itemlist">
                  <div className="list-title">
                    <p>사료명</p>
                  </div>
                  <div className="list-input">
                    <p>{item.feedName}</p>
                  </div>
                  <button onClick={() => { FeedChange(item) }} >수정</button>
                </div>
                <div className="itemlist">
                  <div className="list-title">
                    <p>사료재고량(g)</p>
                  </div>
                  <div className="list-input">
                    <p>{item.feedRemain}</p>
                  </div>
                  <button onClick={() => { FeedDelete(item.manageFeedId) }} >삭제</button>
                </div>
                <div className="itemlist">
                  <div className="list-title">
                    <p>사료구입날짜</p>
                  </div>
                  <div className="list-input">
                    {/* <p>{feedday}</p> */}
                    <p>{feeddayfunc()}</p>
                  </div>
                </div>
                <div className="itemlist">
                  <div className="list-title">
                    <p>초기재고량(g)</p>
                  </div>
                  <div className="list-input">
                    <p>{item.feedInventory}</p>
                  </div>
                </div>
                <div className="itemlist">
                  <div className="list-title">
                    <p>사료구입량(g)</p>
                  </div>
                  <div className="list-input">
                    <p>{item.feedPurchaseAmount}</p>
                  </div>
                </div>

                <div className="itemlist">
                  <div className="list-title">
                    <p>재고하한값(g)</p>
                  </div>
                  <div className="list-input">
                    <p>{item.feedLowLimit}</p>
                  </div>
                </div>
              </styles.ContentItem>
            );
          })}
      </styles.ContentBox>

      <styles.ModalBox className={modal === true ? "open" : "close"}>
        <styles.FeedChangeBox>
          <styles.FeedChangeItem>
            <div className="itemlist">
              <div className="list-title">
                <p>사료명</p>
              </div>
              <div className="list-input">
                <input
                  type="text"
                  name="feedName"
                  className="bg"
                  value={putdata.feedName ?? ''}
                  readOnly
                />
              </div>
            </div>
            <div className="itemlist">
              <div className="list-title">
                <p>사료재고량(g)</p>
              </div>
              <div className="list-input">
                <input
                  type="text"
                  className="bg"
                  name="feedRemain"
                  value={putdata.feedRemain ?? 0}
                  min={0}
                  readOnly
                />
              </div>
            </div>

            <div className="itemlist">
              <div className="list-title">
                <p>초기재고량(g)</p>
              </div>
              <div className="list-input">
                <input
                  type="text"
                  className="bg"
                  name="feedInventory"
                  value={putdata.feedInventory ?? 0}
                  min={0}
                  readOnly
                />
              </div>
            </div>
            <div className="itemlist">
              <div className="list-title">
                <p>사료구입날짜</p>
              </div>
              <div className="list-input">
                <input
                  type="date"
                  name="feedPurchaseDate"
                  value={putdata.feedPurchaseDate || ""}
                  onChange={InputHandler}
                />
              </div>
            </div>

            <div className="itemlist">
              <div className="list-title">
                <p>사료구입량(포대)</p>
              </div>
              <div className="list-input">
                <input
                  type="number"
                  name="feedPurchaseBags"
                  value={putdata.feedPurchaseBags ?? ''}
                  onChange={InputHandler}
                  min={0}
                />
              </div>
            </div>

            <div className="itemlist">
              <div className="list-title">
                <p>포대 단위(kg)</p>
              </div>
              <div className="list-input">
                <input
                  type="number"
                  name="feedPurchaseBagUnit"
                  value={putdata.feedPurchaseBagUnit ?? ''}
                  onChange={InputHandler}
                  min={0}
                />
              </div>
            </div>

            <div className="itemlist">
              <div className="list-title">
                <p>재고하한값(g)</p>
              </div>
              <div className="list-input">
                <input
                  type="number"
                  name="feedLowLimit"
                  value={putdata.feedLowLimit ?? ''}
                  onChange={InputHandler}
                  min="0"
                />
              </div>
            </div>
          </styles.FeedChangeItem>

          <styles.FeedChangeBoxButtonArea>
            <button onClick={() => { Putsubmit() }} >
              수정
            </button>
            <button onClick={() => {
              setPutdata({
                feedName: null,
                feedInventory: null,
                feedRemain: null,
                feedPurchaseDate: null,
                feedPurchaseBags: null,
                feedPurchaseBagUnit: null,
                feedLowLimit: null,
                manageFeedId: null,
              });

              setModal(!modal)
            }} >
              닫기
            </button>
          </styles.FeedChangeBoxButtonArea>
        </styles.FeedChangeBox>
      </styles.ModalBox>
      {deletemodal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deleteCommnetfunc("YES")}
          secondclick={() => deleteCommnetfunc("NO")}
        />
      )}
    </styles.Container>
  );
};

export default Feedmanagement;
